import { render, staticRenderFns } from "./BSMultiStep.vue?vue&type=template&id=162f97a0&"
import script from "./BSMultiStep.vue?vue&type=script&lang=js&"
export * from "./BSMultiStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports